/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)
import LazyLoad from 'vanilla-lazyload';


import Helper from './Classes/Helper';

// import Jump from './Classes/Jump'
// import YoutubeLinks from './Classes/YoutubeLinks';
import Accordion from './Classes/Accordion';
import CV from './Classes/CV';
import Header from "./Classes/Header";
import Footer from "./Classes/Footer";
import FurtherLinks from "./Classes/FurtherLinks";
import BackToTop from "./Classes/BackToTop";
import Sharing from "./Classes/Sharing";
import SideNav from "./Classes/SideNav";
import HighlightSlider from "./Classes/HighlightSlider";
//import StoryHover from "./Classes/StoryHover";
import Gri from "./Classes/Gri";
import FactsFiguresSlider from "./Classes/FactsFiguresSlider";
import Strategy from "./Classes/Strategy";
import PracticalExample from "./Classes/PracticalExample";
import Video from "./Classes/Video";
import Home from "./Classes/Home";
import MovePrevNext from "./Classes/MovePrevNext";
import HeaderImageAnimation from "./Classes/HeaderImageAnimation";
import FootnoteSpan from './Classes/FootnoteSpan';
import TimelineSlider from './Classes/TimelineSlider';
import DetectOs from "./Classes/DetectOs";
import RealVh from "./Classes/RealVh";
import HeaderSingleImageAnimation from "./Classes/HeaderSingleImageAnimation";
import InteractiveNachhaltigkeit from './Classes/InteractiveNachhaltigkeit';
import CustomExtendedSearch from "./Classes/CustomExtendedSearch";

var sideNavInstance = null;
var MovePrevNextInstance = null;
var accordionInstance = null;
var practicalExampleInstance = null;
var CVInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;
var headerInstance = null;
var footerInstance = null;
var furtherLinks = null;
var backToTopInstance = null;
var sharingInstance = null;
var strategyInstance = null;
var highlightSliderInstance = null;
var factsFiguresSliderInstance = null;
// var storyHoverInstance = null;
var homeInstance = null;
var videoInstance = null;
var gri = null;
var footnoteSpan = null;
var timelineSliderInstance = null;
var lazyLoadInstance = null;
var interactiveNachhaltigkeitInstance = null;
var interactiveNachhaltigkeitInstanceMobile = null;
var customExtendedSearch = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }


  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {
  // globally set Language settings for Charts
  // Highcharts.setOptions({
  //   lang: {
  //     numericSymbols: null
  //   },
  // });

  customExtendedSearch = new CustomExtendedSearch();

  lazyLoadInstance = new LazyLoad({
    unobserve_entered: true
  });


  // =======================================
  // Interactive Graphic Instances
  // =======================================
  const nachhaltigLinks = [
    {
      id: 'de-link-1',
      url: '?p=9773',
    },
    {
      id: 'de-link-2',
      url: '?p=9776',
    },
    {
      id: 'de-link-3',
      url: '?p=9785',
    },
    {
      id: 'de-link-4',
      url: '?p=9783',
    },
    {
      id: 'de-link-5',
      url: '?p=9780',
    },

    {
      id: 'fr-link-1',
      url: '?p=10329',
    },
    {
      id: 'fr-link-2',
      url: '?p=10482',
    },
    {
      id: 'fr-link-3',
      url: '?p=10314',
    },
    {
      id: 'fr-link-4',
      url: '?p=11936',
    },
    {
      id: 'fr-link-5',
      url: '?p=10562',
    },
  ];

  const idMap = {
    de: [
      {
        triggers: '#de-trigger-5-1, #de-trigger-5-2, #de-trigger-5-3, #de-trigger-5-4',
        target: '#de-target-5',
        shows: '#de-trigger-4-1, #de-trigger-3-2, #de-trigger-2-3, #de-trigger-1-4'
      },
      {
        triggers: '#de-trigger-4-1, #de-trigger-4-2, #de-trigger-4-3, #de-trigger-4-4',
        target: '#de-target-4',
        shows: '#de-trigger-3-1, #de-trigger-2-2, #de-trigger-1-3, #de-trigger-5-4'
      },
      {
        triggers: '#de-trigger-3-1, #de-trigger-3-2, #de-trigger-3-3, #de-trigger-3-4',
        target: '#de-target-3',
        shows: '#de-trigger-2-1, #de-trigger-1-2, #de-trigger-5-3, #de-trigger-4-4'
      },
      {
        triggers: '#de-trigger-2-1, #de-trigger-2-2, #de-trigger-2-3, #de-trigger-2-4',
        target: '#de-target-2',
        shows: '#de-trigger-1-1, #de-trigger-5-2, #de-trigger-4-3, #de-trigger-3-4'
      },
      {
        triggers: '#de-trigger-1-1, #de-trigger-1-2, #de-trigger-1-3, #de-trigger-1-4',
        target: '#de-target-1',
        shows: '#de-trigger-5-1, #de-trigger-4-2, #de-trigger-3-3, #de-trigger-2-4',
        default:true
      },
    ],

    fr: [
      {
        triggers: '#fr-trigger-5-1, #fr-trigger-5-2, #fr-trigger-5-3, #fr-trigger-5-4',
        target: '#fr-target-5',
        shows: '#fr-trigger-4-1, #fr-trigger-3-2, #fr-trigger-2-3, #fr-trigger-1-4'
      },
      {
        triggers: '#fr-trigger-4-1, #fr-trigger-4-2, #fr-trigger-4-3, #fr-trigger-4-4',
        target: '#fr-target-4',
        shows: '#fr-trigger-3-1, #fr-trigger-2-2, #fr-trigger-1-3, #fr-trigger-5-4'
      },
      {
        triggers: '#fr-trigger-3-1, #fr-trigger-3-2, #fr-trigger-3-3, #fr-trigger-3-4',
        target: '#fr-target-3',
        shows: '#fr-trigger-2-1, #fr-trigger-1-2, #fr-trigger-5-3, #fr-trigger-4-4'
      },
      {
        triggers: '#fr-trigger-2-1, #fr-trigger-2-2, #fr-trigger-2-3, #fr-trigger-2-4',
        target: '#fr-target-2',
        shows: '#fr-trigger-1-1, #fr-trigger-5-2, #fr-trigger-4-3, #fr-trigger-3-4'
      },
      {
        triggers: '#fr-trigger-1-1, #fr-trigger-1-2, #fr-trigger-1-3, #fr-trigger-1-4',
        target: '#fr-target-1',
        shows: '#fr-trigger-5-1, #fr-trigger-4-2, #fr-trigger-3-3, #fr-trigger-2-4',
        default:true
      },
    ]
  };

  interactiveNachhaltigkeitInstance = new InteractiveNachhaltigkeit({
    graphicQuery: '.svg-nachhaltigkeit',
    idMap: idMap,
    links: nachhaltigLinks
  });

  interactiveNachhaltigkeitInstanceMobile = new InteractiveNachhaltigkeit({
    graphicQuery: '.svg-nachhaltigkeit-mobile',
    idMap: idMap,
    links: nachhaltigLinks
  });

  new DetectOs();
  new RealVh();

  accordionInstance = new Accordion({
    accordions: '.ns-accordion__head'
  });

  practicalExampleInstance = new PracticalExample();

  CVInstance = new CV();
  homeInstance = new Home();

  headerInstance = new Header({
    submenuSelector: '.menu__wrap--level-1',
    submenuTogglerSelector: '.menu__item--has-children .menu__link--level-0',
    menuTogglerSelector: '.js-menu-toggle',
    menuContainerSelector: '.header__navigation',
    searchTogglerSelector: '.js-search-toggle',
    searchContainerSelector: '.header__searchform',
    headerSelector: '.header',
    headerPolyfillSelector: '.header-polyfill',
    scrollDistance: 260,
    metaTogglerSelector: '.js-meta-options',
    metaContainerSelector: '.header__meta-group--desktop'
  });

  sideNavInstance = new SideNav({ headerRef: headerInstance });

  footerInstance = new Footer({
    dropdownWrapperSelector: '.js-dropdown-wrapper',
    dropdownToggleSelector: '.js-dropdown-toggle',
    dropdownDropSelector: '.js-dropdown',
    needsBackdrop: false
  });

  backToTopInstance = new BackToTop({
    buttonClass: '.js-backtotop-toggle',
    stickyClass: '.prev-next__inner',
    fadeInPosition: 100,
    correction: 0,
    toolbarClass: '.sharing-to-top'
  });

  sharingInstance = new Sharing({
    sharingClass: '.sharing',
    buttonClass: '.js-sharing-toggle'
  });

  highlightSliderInstance = new HighlightSlider({
    outerWrapperSelector: '.ns-highlights__inner'
  })

  factsFiguresSliderInstance = new FactsFiguresSlider({
    outerWrapperSelector: '.ns-facts-figures__inner'
  });

  strategyInstance = new Strategy({
    strategyItem: '.ns-strategy__item'
  });

  // storyHoverInstance = new StoryHover();

  videoInstance = new Video();

  gri = new Gri();

  MovePrevNextInstance = new MovePrevNext();

  footnoteSpan = new FootnoteSpan();

  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  // const headerImageAnimation = new HeaderImageAnimation({
  //   selector: '.js-header-animation'
  // });

  const headerSingleImageAnimation = new HeaderSingleImageAnimation({
    selector: '.js-header-animation'
  });

  timelineSliderInstance = new TimelineSlider({
    outerWrapperSelector: '.ns-timeline'
  });

});
